<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  export let section;
  onMount(() => {
    setTimeout(() => {
      if (section == undefined || section == '') {
        section = '';
      }
      navigate('/' + section + window.location.hash);
    }, 100);
  });
</script>
